<h5 class="text-primary mb-3">Alarm</h5>
@if (alarm(); as alarm) {
  <table class="table table-sm">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>State</td>
        <td [@pulse]="alarm.state">{{ alarm.state }}</td>
      </tr>
      <tr>
        <td>Time</td>
        <td [@pulse]="alarm.time">{{ alarm.time }}</td>
      </tr>
      <tr>
        <td>Type</td>
        <td [@pulse]="alarm.typeCode">{{ alarm.typeCode }}</td>
      </tr>
    </tbody>
  </table>
} @else {
  There is no alarm set.
}